import type { InnogyComponentRendering } from '@core/jss-models';
import { getDroplinkValue, getFieldValue } from '@core/jss-utils';

export function backgroundImageFromRendering(
  rendering: InnogyComponentRendering
) {
  const imageField =
    getFieldValue<{ src?: string }>(rendering.fields, 'image') ?? {};
  const imageUrl =
    Object.keys(imageField).length !== 0 ? `url("${imageField.src}")` : '';

  return {
    'background-image': imageUrl,
    'background-repeat': getDroplinkValue(rendering.fields, 'imageRepeat'),
    'background-size': getDroplinkValue(rendering.fields, 'imageSize'),
    'background-position': `${getDroplinkValue(
      rendering.fields,
      'horizontalAlignment'
    )} ${getDroplinkValue(rendering.fields, 'verticalAlignment')}`,
  };
}
